import { render, staticRenderFns } from "./AllUrls.vue?vue&type=template&id=5cb3dd0b&scoped=true&"
import script from "./AllUrls.vue?vue&type=script&lang=ts&"
export * from "./AllUrls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3dd0b",
  null
  
)

export default component.exports